<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'IntegrityForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  props: {
    tom: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.transferControlDesc"
            property-code="tom.transferControlDesc"
            label="Beschreibung der Weitergabekontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.inputControlDesc"
            property-code="tom.inputControlDesc"
            label="Beschreibung der Eingabekontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.availControlDesc"
            property-code="tom.availControlDesc"
            label="Beschreibung der Verfügbarkeitskontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.recoverabilityDesc"
            property-code="tom.recoverabilityDesc"
            label="Beschreibung der Wiederherstellbarkeit"
          />
        </v-flex>

      </v-layout>

    </v-container>
  </v-form>
</template>
